// @flow
import get from 'lodash/get';
import { connect } from 'react-redux';
import { compose } from 'redux';
import type { Dispatch } from 'redux';
import { injectIntl } from 'react-intl';
import { searchParametersSelector, autoCompleteSelector } from '../../../Serp/selectors';
import {
  setSearchParams,
  fetchAutocompleteRequest,
  activateUserSearchInteraction,
  setShouldResetWhere,
} from '../../../Serp/actions';
import HeaderSerp from './index';
import { VERTICAL_NAMES } from '../../constants/common';
import { Router } from '../../../router';
import {
  clearSearchParameters,
  transformSearchParametersToQueryObject,
} from '../../../utils/searchParameters';
import { showSourcesLoader } from '../../../Sources/loader/actions';
import {
  verticalNameSelector,
  allowAutoCompleteFieldsSelector,
  getCountryCode,
} from '~/common/selectors/config';

function hasAutoCompleteFieldsInSerpPageSearch(state) {
  return (
    verticalNameSelector(state) !== VERTICAL_NAMES.jobs && // prevent autocomplete in jobs vertical
    get(allowAutoCompleteFieldsSelector(state), 'serpPageSearch')
  );
}

export const onSearchChanged = (dispatch: Dispatch<*>) => ({
  what,
  verticalName,
  searchParameters,
}: {
  what: string,
  verticalName: VerticalName,
  searchParameters: Object,
}) => {
  if (what === get(searchParameters, 'whatOriginalTyped')) {
    return false;
  }

  const newSearchParameters = {
    ...clearSearchParameters(searchParameters),
    what_d: what,
    whatAccented: what,
    routeName: 'serp_search',
    pageName: 'serp',
    isSeoUrl: false,
    page: 1,
  };

  dispatch(setShouldResetWhere());
  dispatch(activateUserSearchInteraction());
  dispatch(setSearchParams(newSearchParameters, true));

  // Force showing sources loader when updating the search
  dispatch(showSourcesLoader());

  const query = transformSearchParametersToQueryObject(newSearchParameters, verticalName);

  return Router.pushRoute('serp_search', query).then(() => window.scrollTo(0, 0));
};

export const mapStateToProps = (state: Object): Object => ({
  searchParameters: searchParametersSelector(state),
  verticalName: verticalNameSelector(state),
  countryCode: getCountryCode(state),
  hasAutoCompleteFieldsInSerpPageSearch: hasAutoCompleteFieldsInSerpPageSearch(state),
  autoComplete: autoCompleteSelector(state).reduce(
    (acc, current) =>
      acc.concat({
        label: current.text || current.value,
        value: current.value,
      }),
    []
  ),
});

export const mapDispatchToProps = (dispatch: Dispatch<*>): Object => ({
  onSearchChanged: onSearchChanged(dispatch),
  fetchAutocompleteRequest: (data: Object) => dispatch(fetchAutocompleteRequest({ search: data })),
});

const HeaderSerpContainer = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(HeaderSerp);

export default HeaderSerpContainer;



// WEBPACK FOOTER //
// ./app/common/Header/HeaderSerp/container.js